// extracted by mini-css-extract-plugin
export default {"root":"DataTable_root__lY1vc","placeHolderShimmer":"DataTable_placeHolderShimmer__zMc-n"};